// material-ui
import { CardActions } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { Button, Divider, Grid } from '@mui/material'
import RedQuickAlert from 'components/RedQuickAlert'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import ReleaseZoneForm from 'components/ReleaseZoneForm'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_releaseZone,
  get_selected_releaseZone,
  is_releaseZone_busy,
  setSelectedreleaseZone,
} from 'features/releaseZone/releaseZone-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let releaseZone_list = useSelector(get_all_releaseZone)
  let releaseZone_busy = useSelector(is_releaseZone_busy)
  let releaseZone = useSelector(get_selected_releaseZone)
  const [releaseZoneDirty, setReleaseZoneDirty] = React.useState(null)
  const [releaseZoneValid, setReleaseZoneValid] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [releaseZoneChanges, setReleaseZoneChanges] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_release_zones({ ok: false }))
    }
  }, [claims?.player])

  function releaseZoneComponent(): any {
    return (
      <>
        {SC.sharedList(
          (releaseZone_list || []).filter((x) => !x.deleted),
          SC.sharedListItemBuilder,
          (item) => {
            return {
              name: item?.name || TitleService('Unknown'),
              date: item?.created || item.updated,
              statusColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.dark.main
                  : theme.palette.primary.light,
              getIcon: () => {
                return (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-map-2"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#597e8d"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="18" y1="6" x2="18" y2="6.01" />
                    <path d="M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5" />
                    <polyline points="10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15" />
                    <line x1="9" y1="4" x2="9" y2="17" />
                    <line x1="15" y1="15" x2="15" y2="20" />
                  </svg>
                )
              },
            }
          },
          (item) => {
            dispatch(setSelectedreleaseZone(item?.id))
            setReleaseZoneChanges({})
            setReleaseZoneValid(null)
            setReleaseZoneDirty(null)
            setContextId(uuid())
          },
        )}
      </>
    )
  }

  let output_releaseZoneComponent = releaseZoneComponent()

  function releaseZoneItemForm(
    storeReleaseZoneAsync: any,
    deleteReleaseZoneAsync: any,
  ): any {
    return (
      <>
        <Grid item xs={12} sm={12} md={12}>
          <ReleaseZoneForm
            page={undefined}
            form={{ ...(releaseZone || {}), ...(releaseZoneChanges || {}) }}
            onUpdate={(update, valid, dirty) => {
              setReleaseZoneChanges(update)
              setReleaseZoneValid(valid)
              setReleaseZoneDirty(dirty)
            }}
            context={{
              id: contextId,
            }}
          />
        </Grid>
        <Divider />
        <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
          <Grid container spacing={2}>
            <Grid item>
              <AnimateButton>
                <Button
                  variant="contained"
                  onClick={async () => {
                    dispatch(setSelectedreleaseZone(null))
                    setReleaseZoneChanges({})
                    setReleaseZoneValid(null)
                    setReleaseZoneDirty(null)
                  }}
                >
                  {TitleService('New')}
                </Button>
              </AnimateButton>
            </Grid>
            {releaseZoneDirty && releaseZoneValid && (
              <Grid item>
                <AnimateButton>
                  <Button
                    variant="contained"
                    onClick={async () => {
                      await dispatch(storeReleaseZoneAsync)
                      dispatch(setSelectedreleaseZone(null))
                      setReleaseZoneChanges({})
                      setReleaseZoneValid(null)
                      setReleaseZoneDirty(null)
                      setContextId(uuid())
                    }}
                  >
                    {TitleService('Save')}
                  </Button>
                </AnimateButton>
              </Grid>
            )}
            {releaseZone?.id && (
              <Grid item>
                <RedQuickAlert
                  button={
                    <Button
                      variant="contained"
                      sx={{
                        background: theme.palette.error.main,
                        '&:hover': { background: theme.palette.error.dark },
                      }}
                      disabled={releaseZone_busy}
                      onClick={async () => {}}
                    >
                      {TitleService('Delete')}
                    </Button>
                  }
                  cancelText={TitleService('No')}
                  affirmativeText={TitleService('Yes')}
                  onOk={async () => {
                    await dispatch(deleteReleaseZoneAsync)
                    dispatch(setSelectedreleaseZone(null))
                    setReleaseZoneChanges({})
                    setReleaseZoneValid(null)
                    setReleaseZoneDirty(null)
                    setContextId(uuid())
                  }}
                  title={TitleService('Are you sure?')}
                  description={TitleService('This is a system wide change.')}
                />
              </Grid>
            )}
          </Grid>
        </CardActions>
      </>
    )
  }

  let output_releaseZoneItemForm = releaseZoneItemForm(
    autoThunks.storeReleaseZoneAsync({
      releaseZone: (() => {
        function getCurrentReleaseZone(): any {
          return {
            ...(releaseZone || {}),
            ...(releaseZoneChanges || {}),
          }
        }
        return getCurrentReleaseZone()
      })(),
    }),
    autoThunks.deleteReleaseZoneAsync({
      releaseZoneId: (() => {
        function getCurrentReleaseZoneId(): any {
          return releaseZone?.id
        }
        return getCurrentReleaseZoneId()
      })(),
    }),
  )

  function main_card(modelList: any, modelForm: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Busy />
        <Grid item xs={6}>
          <MainCard title={TitleService('Release Zones')}>{modelList}</MainCard>
        </Grid>
        <Grid item xs={6}>
          <MainCard title={releaseZone?.name || TitleService('Release Zone')}>
            {modelForm}
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(
    output_releaseZoneComponent,
    output_releaseZoneItemForm,
  )

  return output_main_card
}
